module.exports = __webpack_public_path__ + "img/visa.542a55ba.png";